import db from './indexDB'

export default {
    /**
     * Clear from the database
     */
    async clearMasterData() {
        await db.spraySpraies.clear();
        await db.sprayPlants.clear();
        await db.sprayDivisions.clear();
        await db.sprayLocations.clear();
        await db.spraySprayConfigurations.clear();
    },
    /**
    * Add to IndexDB
    * @user {Object} -- Spray Master Data
    */
    async addMasterData(masterData) {
        await this.addSprayPlants(masterData.masterData.Plants);
        await this.addSpraySpraies(masterData.masterData.Spraies);
        await this.addSprayDivisions(masterData.masterData.Divisions);
        await this.addSprayLocations(masterData.masterData.Locations);
        await this.addSpraySprayConfigurations(masterData.masterData.SprayConfigurations);
    },
    async getMasterData() {
        var spraies = await this.getSpraySpraies();
        var plants = await this.getSprayPlants();
        var divisions = await this.getSprayDivisions();
        var locations = await this.getSprayLocations();
        var sprayConfigurations = await this.getSpraySprayConfigurations();
        var masterData = {
            Spraies: spraies,
            Plants: plants,
            Divisions: divisions,
            Locations: locations,
            SprayConfigurations: sprayConfigurations
        };
        return masterData
    },
    async addSpraySpraies(spraies) {
        await db.spraySpraies.bulkPut(spraies);
    },
    async addSprayPlants(plants) {
        await db.sprayPlants.bulkPut(plants);
    },
    async addSprayDivisions(divisions) {
        await db.sprayDivisions.bulkPut(divisions);
    },
    async addSprayLocations(locations) {
        await db.sprayLocations.bulkPut(locations);
    },
    async addSpraySprayConfigurations(sprayConfigurations) {
        await db.spraySprayConfigurations.bulkPut(sprayConfigurations);
    },
    async getSpraySpraies() {
        return await db.spraySpraies.toArray();
    },
    async getSprayPlants() {
        return await db.sprayPlants.toArray();
    },
    async getSprayDivisions() {
        return await db.sprayDivisions.toArray();
    },
    async getSprayLocations() {
        return await db.sprayLocations.toArray();
    },
    async getSpraySprayConfigurations() {
        return await db.spraySprayConfigurations.toArray();
    },
    async getUnAddSpraies() {
        return await db.sprayUnAddSpraies.toArray();
    },
    async getUnUpdateSpraies() {
        return await db.sprayUnUpdateSpraies.toArray();
    },
    async getUnDeleteSprayIDs() {
        return await db.sprayUnDeleteSprayIDs.toArray();
    },
    async addUnAddSpray(spray) {
        await db.sprayUnAddSpraies.put(spray);
        await db.spraySpraies.add(spray);
    },
    async addUnUpdateSpray(spray) {
        await db.sprayUnUpdateSpraies.put(spray);
        await db.spraySpraies.update([spray.SprayID, spray.AddDateTime], spray);
    },
    async addUnDeleteSprayID(spray) {
        await db.sprayUnDeleteSprayIDs.put({SprayID:spray.SprayID});
        await db.spraySpraies.delete([spray.SprayID, spray.AddDateTime]);
    },
    async clearUnAddSpraies() {
        return await db.sprayUnAddSpraies.clear();
    },
    async clearUnUpdateSpraies() {
        return await db.sprayUnUpdateSpraies.clear();
    },
    async clearUnDeleteSprayIDs() {
        return await db.sprayUnDeleteSprayIDs.clear();
    }
}